let token: string | null = null;
const listeners = new Set<(t: string | null) => void>();

export const memoryTokenStore = {
  getToken: () => token,
  setToken: (t: string | null) => {
    token = t;
    listeners.forEach((l) => l(token));
  },
  subscribe: (listener: (t: string | null) => void) => {
    listeners.add(listener);

    listener(token);

    return () => {
      listeners.delete(listener);
    };
  },
};
